module.exports = __webpack_public_path__ + "046b6e4d78bc84f577f6da5352ae8854.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/flippers.png
// module id = 2396
// module chunks = 0